import { getSystemRoofType } from '../../compatibility'
import { K2RailType, K2RoofMaterialType } from './K2Types'

export const railSystemEnum = ['CROSSRAIL', 'SIMPLE_TILT_US'] as const

export const railSystemMap: Record<typeof railSystemEnum[number], K2RailType> = Object.freeze({
  CROSSRAIL: 'crossrail',
  SIMPLE_TILT_US: 'simpleTilt',
})

export function railSystemToEndpointPathSegment(railSystem: string): K2RailType {
  let pathSegment = railSystemMap[railSystem]
  if (!pathSegment) {
    throw Error(`Rail system ${railSystem} is not valid`)
  }
  return pathSegment
}

export function getSystemRoofMaterial() {
  const roofType = getSystemRoofType()
  if (!roofType) throw Error('No roof type')
  const roofTypeToMaterialMap: Record<string, K2RoofMaterialType> = {
    'Tile Clay': 'tile',
    'Tile Concrete': 'tile',
    'Tile Slate': 'tile',
    'Composition / Asphalt Shingle': 'comp',
    'Metal Standing Seam': 'standingseam',
    Trapezoidal: 'trapezoidal',
    'Rolled Asphalt': 'comp',
    'Flat Concrete': 'concrete',
    'Membrane EPDM': 'concrete',
  }
  const roofMaterial = roofTypeToMaterialMap[roofType] || roofType
  return roofMaterial
}

export function getRoofCoveringToRoofTypeMap(): Record<string, string[]> {
  return {
    comp: ['Composition / Asphalt Shingle', 'Rolled Asphalt'],
    tile: ['Tile Clay', 'Tile Slate', 'Tile Concrete'],
    standingseam: ['Metal Standing Seam'],
    corrugated: ['Corrugated'],
    trapezoidal: ['Trapezoidal'],
    concrete: ['Flat Concrete', 'Membrane EPDM'],
  }
}

export function metersToInches(meters: number) {
  return meters * 39.3701
}

export function getTiltAngleBasedOnRoofShape(k2RailType: K2RailType, roofShape: string, slope: number) {
  if (k2RailType === 'simpleTilt') {
    if (slope <= 5) {
      return '0-5'
    } else {
      console.error('Invalid slope:', slope)
      return ''
    }
  }
  if (roofShape === 'monoslope') {
    if (slope < 3) return '0-3'
    if (slope < 10) return '3-10'
    return '10-30'
  } else if (roofShape === 'gable') {
    if (slope < 20) return '7-20'
    if (slope < 27) return '20-27'
    return '27-45'
  } else {
    console.error('Invalid roof shape:', roofShape)
    return ''
  }
}
